import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgNavAssetsFill = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path fill="#88827E" d="m11 3 2 2h9v16H2V3h9ZM7 14h4v5l6-7h-4V7l-6 7Z" />
  </svg>
);
export default SvgNavAssetsFill;
